import { Container } from '@mui/material';
import { useCallback, useEffect, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import AdView from '../../components/ui/AdView';
import { Ad_RefreshKey } from '../../recoil/states';
import CommonUtil from '../../utils/CommonUtil';

const Index = () => {
  const ad_RefreshKey = useRecoilValue(Ad_RefreshKey); // 광고 UI 랜더링 처리를 위해 사용되는 state

  const iframeRef = useRef<HTMLIFrameElement>(null);
  const isFirst = useRef<Boolean>(true);

  // iframe 내용 높이에 맞춰 자동 리사이즈
  const resizeIframe = useCallback(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    try {
      const body = iframe.contentWindow?.document?.body;
      if (!body) return;
      // 필요하면 Math.max(기존높이, offsetHeight)로 변경
      iframe.style.height = `${body.offsetHeight}px`;
    }
    catch (e) {
      // (다른 도메인이면 접근 불가)
      console.error("iframe resize failed:", e);
    }

    if (isFirst.current) {
      CommonUtil.scrollTo("#rootArea", 0, 0); // 사진편집 상단 영역으로 스크롤바 자동 이동
      isFirst.current = false;
    }
  }, []);

  useEffect(() => {
    (window as any).__resizeImageMakerIframe__ = resizeIframe; // 전역에 걸기
    return () => { delete (window as any).__resizeImageMakerIframe__; };
  }, [resizeIframe]);

  // onLoad 타입을 맞춰줌
  const handleLoad: React.ReactEventHandler<HTMLIFrameElement> = () => {
    // 렌더 직후 한 프레임 뒤에 측정(안전)
    requestAnimationFrame(resizeIframe);
  };

  return (
    <Container fixed={true} maxWidth="md" sx={{ padding: "10px" }} id="rootArea">
      <AdView googleAdsense={{ rootid: "adsense_Ad_Web_Root_1", slot: "3579731057", height: CommonUtil.isMobileOs() ? 50 : 100 }}
        kakaoAdfit={{ rootid: "kakao_Ad_Web_Root_1", unit: "DAN-1ib391cgs3asj", width: 320, height: 50 }}
        marginStyle="0 0 10px"
        refreshKey={ad_RefreshKey}
      />

      <div style={{ textAlign: "center" }}>
        <iframe
          id="frm_image_maker_content"
          scrolling="no"
          ref={iframeRef}
          src="/image_maker_iframe.html"
          style={{ width: "100%", border: "0", marginBottom: "10px" }}
          onLoad={handleLoad}
        />
      </div>

      <AdView googleAdsense={{ rootid: "adsense_Ad_Web_Root_2", slot: "6619514281", responsiveYn: "Y" }}
        kakaoAdfit={{ rootid: "kakao_Ad_Web_Root_2", unit: "DAN-1jecnsm8z0yeu", width: 300, height: 250 }}
        refreshKey={ad_RefreshKey}
      />
    </Container>
  )
}

export default Index;
